export default __webpack_public_path__ + "static/media/visiontrak-help-centre-hero.6a0c2884.png";